/**
 * "I wanted to pay" survives the sign-in round trip. Anonymous visitors who
 * press Subscribe must authenticate first (credits live on an account), and
 * prod data showed 63% of them never came back to the plan: the intent was
 * simply lost across the Auth0 redirect. Per tab (sessionStorage) and short-
 * lived, so a stale wish from an old visit never pops up unexpectedly.
 */
const KEY = 'stt_pending_plan'
const TTL_MS = 30 * 60 * 1000

export function savePendingPlan(plan: string): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ plan, ts: Date.now() }))
  } catch {
    // storage unavailable — the user just picks the plan again after login
  }
}

/** Read-and-clear: the intent is consumed exactly once. */
export function takePendingPlan(): string | null {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    sessionStorage.removeItem(KEY)
    const { plan, ts } = JSON.parse(raw) as { plan?: unknown; ts?: unknown }
    if (typeof plan !== 'string' || typeof ts !== 'number') return null
    return Date.now() - ts < TTL_MS ? plan : null
  } catch {
    return null
  }
}
